var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonWhiteButton",style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }